export default {"src":"/_next/static/media/star-active.1deebbda.svg","height":12,"width":14,"blurWidth":0,"blurHeight":0};